// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"51e4ed31","453":"67a00c5d","455":"05a76e52","977":"ae4b12ce"}[chunkId] + ".chunk.js";
};